'use client'

import { ErrorBoundary, ErrorBoundaryProps } from 'react-error-boundary'
import { useSession } from 'next-auth/react'
import { ErrorFallback } from './error-fallback'
import { errorsServices, ReportErrorDto } from '@/entities/errors'

type ErrorBoundaryProviderProps = {
  children: React.ReactNode
}

export function ErrorBoundaryProvider({ children }: ErrorBoundaryProviderProps) {
  const { data: session } = useSession()

  const handleError: ErrorBoundaryProps['onError'] = (error, info) => {
    console.error('Error caught by ErrorBoundary:', error)
    console.error('Component stack:', info.componentStack)

    const errorData: ReportErrorDto = {
      error_name: error.name,
      error_message: error.message,
      error_stack: error.stack || null,
      url: typeof window !== 'undefined' ? window.location.href : '',
      timestamp: new Date().toISOString(),
      user_agent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
      user_id: session?.user?.data?.id?.toString() || null,
      user_email: session?.user?.data?.email || session?.user?.email || null,
      component_stack: info.componentStack || null,
    }

    errorsServices.reportError(errorData).catch((err) => {
      console.error('Failed to report error to server:', err)
    })
  }

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback} onError={handleError}>
      {children}
    </ErrorBoundary>
  )
}
